import { PredefinedSubscriptionAddon } from "types/addons";
import { isProduction } from "utils/environment";

export const SUBSCRIPTION_ADDON_REQUESTS_BOOST_1M: PredefinedSubscriptionAddon =
  {
    label: "Requests Boost",
    type: "REQUESTS_BOOST_1M",
    description:
      "Adds an additional 1 million requests to the daily request limit.",
    availableFor: ["DEVELOPER", "ENTERPRISE"],
    stripePriceId: isProduction()
      ? "price_1NlYz0ASZltP0rL6ptPFofdi"
      : "price_1NlYtIASZltP0rL6LDkaLyIi",
    stripeProductId: isProduction()
      ? "prod_OX5zN7JaZ3KCWl"
      : "prod_OQ7nDIY7pg72dd",
  };

export const SUBSCRIPTION_ADDON_REQUESTS_BOOST_300K: PredefinedSubscriptionAddon =
  {
    label: "Requests Boost",
    type: "REQUESTS_BOOST_300K",
    description:
      "Adds an additional 300,000 requests to the daily request limit.",
    availableFor: ["HOBBY"],
    stripePriceId: isProduction()
      ? "price_1NlYw7ASZltP0rL6kzQcFeyv"
      : "price_1NlYvuASZltP0rL60Gz7s2RC",
    stripeProductId: isProduction()
      ? "prod_OYgICbOiKfPn2N"
      : "prod_OYgIjpV1XAYyW5",
  };

export const SUBSCRIPTION_ADDONS: PredefinedSubscriptionAddon[] = [
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_1M,
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_300K,
];

export const REQUESTS_BOOST_ADDONS: PredefinedSubscriptionAddon[] = [
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_1M,
  SUBSCRIPTION_ADDON_REQUESTS_BOOST_300K,
];
